import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service'
import { appConstants } from '../../../app.constants'

import { IncentiveMode } from '../../../shared/enums/incentive-mode.enum'
import { Incentive } from '../../../shared/interfaces/resources/incentive.interface'
import { Theme } from '../../../shared/interfaces/resources/theme.interface'
import { IncentiveService } from '../../../shared/services/incentive.service'
import { MetaService } from '../../../shared/services/meta.service'
import { ThemeService } from '../../../shared/services/theme.service'
import { IncentiveFamilyService } from '../../../shared/services/incentive-family.service'
import { IncentiveFamily } from '../../../shared/enums/incentive.family'

@Component({
  selector: 'app-incentive-detail',
  templateUrl: './incentive-detail.component.html',
  styleUrls: ['./incentive-detail.component.scss']
})
export class IncentiveDetailComponent implements OnInit {
  incentive: Incentive
  comparatorIncentiveIds: string[]
  themes: Theme[]
  cyprusNote: string = appConstants.cyprusNote
  incentiveFamily: IncentiveFamily;

  constructor(
    private activatedRoute: ActivatedRoute,
    private incentiveService: IncentiveService,
    private themeService: ThemeService,
    private metaService: MetaService,
    private breadcrumbService: BreadcrumbService,
    private incentiveFamilyService: IncentiveFamilyService
  ) {}

  ngOnInit(): void {
    this.incentiveFamily = this.incentiveFamilyService.family
    this.activatedRoute.params.subscribe((params: Params) => {
      this.incentiveService
        .show(params['id'])
        .then((incentiveRes: Incentive) => {
          this.incentive = incentiveRes
          this.comparatorIncentiveIds = [
            this.incentive.id,
            ...this.incentive.similarIncentiveIds
          ]

          this.breadcrumbService.breadcrumbLinks.next([
            { label: 'Countries', path: '/countries' },
            {
              label: this.incentive.country.label,
              path: `/countries/${this.incentive.country.id}`
            },
            {label: this.incentiveFamilyService.families.find(f => f.id === this.incentiveFamily)?.label},
            { label: this.incentive.label }
          ])

          this.metaService.setDynamicTags({
            title: `${this.incentive.label} details - ${this.incentive.country.label}`,
            description: `Detailed overview of the policy design features of the ${this.incentive.label} in ${this.incentive.country.label}. Data is based on the OECD R&D tax incentive survey.`,
            path: `incentives/${this.incentive.id}`
          })
        })

      this.themeService
        .list({ mode: IncentiveMode.Detail, dataset: this.incentiveFamily })
        .then((themeRes: Theme[]) => {
          this.themes = themeRes

          this.themes.forEach((theme: Theme) => {
            theme.isCollapsed = theme.id !== 'general'
          })
        })
    })
  }
}
